"use client"

// import { useState } from "react"
import { Button } from "./components/ui/button"
import { Card, CardContent } from "./components/ui/card"
import { Label } from "./components/ui/label"
import { Textarea } from "./components/ui/textarea"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./components/ui/select"
import { RadioGroup, RadioGroupItem } from "./components/ui/radio-group"
import { Progress } from "./components/ui/progress"
import { ChevronLeft, ChevronRight, Heart, CheckCircle } from "lucide-react"
import "../src/styles/globals.css"
import { useState, useEffect } from "react"
const ratingOptions = [
  "Strongly Disagree",
  "Disagree",
  "Neutral",
  "Agree",
  "Strongly Agree",
]

const departments = ["Doctor", "Staff"]

const initialFormData = {
  department: "",
}

// const steps = [
//   { id: "department", title: "Employee Category", type: "select" },
//   { id: "visionValues", title: "The hospital's vision and values are clearly communicated.", type: "rating", category: "Organisational" },
//   { id: "motivated", title: "I am motivated to contribute to the hospital's success.", type: "rating", category: "Organisational" },
//   { id: "grievances", title: "Employee grievances are addressed fairly.", type: "rating", category: "Organisational" },
//   { id: "ethicalStandards", title: "The hospital complies with ethical and professional standards.", type: "rating", category: "Organisational" },
//   { id: "safetyConcerns", title: "Work place encourages reporting of safety concerns without fear.", type: "rating", category: "Work Environment" },
//   { id: "constructiveFeedback", title: "I receive constructive feedback on my work.", type: "rating", category: "Work Environment" },
//   { id: "timelyInfo", title: "Important information is shared in a timely manner.", type: "rating", category: "Communication" },
//   { id: "learnSkills", title: "I am encouraged to learn new skills.", type: "rating", category: "Growth & Development" },
//   { id: "salaryPayments", title: "Salary payments are made accurately and on time.", type: "rating", category: "Pay & Benefits" },
//   { id: "clinicalCooperation", title: "Is there a good cooperation between clinical and non-clinical departments?", type: "rating", category: "Collaboration" },
//   { id: "suggestions", title: "Suggestions, If any", type: "textarea", category: "Open Feedback" },
// ]

export default function HospitalPolicySurveyForm() {
  const [formData, setFormData] = useState(initialFormData)
  const [currentStep, setCurrentStep] = useState(0)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [steps, setSteps] = useState([]);
  useEffect(() => {
    fetch(
      "https://feedback.pranaamhospitals.com/index.php/EmployeeSurvey/questions"
    )
      .then((res) => res.json())
      .then((data) => {
  
        const dynamicSteps = [
          {
            id: "department",
            title: "Staff Category",
            type: "select",
          },
  
          ...data.data.map((q) => ({
            id: `question_${q.id}`,
            question_id: q.id,
            title: q.question_name.trim(),
            type: q.id === "11" ? "textarea" : "rating",
          })),
        ];
  
        setSteps(dynamicSteps);
  
        // Dynamic form data
        const dynamicFormData = {
          department: "",
        };
  
        data.data.forEach((q) => {
          if (q.id === "11") {
            dynamicFormData[`question_${q.id}`] = "";
          } else {
            dynamicFormData[`question_${q.id}`] = {
              selectedOption: "",
            };
          }
        });
  
        setFormData(dynamicFormData);
      })
      .catch((err) => console.log(err));
  }, []);
  if (steps.length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }
  const currentStepData = steps[currentStep]
  const progress = ((currentStep + 1) / steps.length) * 100

  const updateOption = (field, selectedOption) => {
    setFormData(prev => ({ ...prev, [field]: { ...prev[field], selectedOption } }))
  }

  const updateTextarea = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }))
  }

  const canProceed = () => {
    if (currentStepData.id === "department") {
      return formData.department !== "";
    }
  
    if (currentStepData.type === "rating") {
      return (
        (formData[currentStepData.id]?.selectedOption || "") !== ""
      );
    }
  
    return true;
  };
  

  const nextStep = () => {
    if (canProceed() && currentStep < steps.length - 1) setCurrentStep(prev => prev + 1)
  }

  const prevStep = () => {
    if (currentStep > 0) setCurrentStep(prev => prev - 1)
  }

  const handleSubmit = async () => {
    const answers = steps
    .filter((step) => step.question_id)
    .map((step) => ({
      question_id: step.question_id,
      answer:
        step.type === "textarea"
          ? formData[step.id]
          : formData[step.id]?.selectedOption || "",
    }));

    const payload = {
      department: formData.department,
      created_at: new Date().toISOString().split("T")[0],
      answers: JSON.stringify(answers),
    }
    

    const response = await fetch(
      "https://feedback.pranaamhospitals.com/index.php/EmployeeSurvey/employee_survey_form",
      {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(payload).toString(),
      }
    )

    if (response.ok) setIsSubmitted(true)
  }


  if (isSubmitted) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4 bg-background">
        <Card className="max-w-md w-full shadow-xl border-0">
          <CardContent className="p-8 text-center space-y-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle className="w-8 h-8 text-green-600" />
            </div>
            <h2 className="text-2xl font-bold text-foreground">Thank You!</h2>
            <p className="text-muted-foreground leading-relaxed">
              Your feedback has been submitted successfully. Your input helps us improve Pranaam Hospitals for everyone.
            </p>
          </CardContent>
        </Card>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="bg-card border-b border-border">
        <div className="max-w-2xl mx-auto px-4 py-6">
          <div className="flex items-center justify-center mb-6">
            <img src="/images/pranaam-logo.png" alt="Pranaam Hospitals" className="h-12 w-auto" />
          </div>
          <div className="space-y-3">
            <div className="flex items-center justify-between text-sm text-muted-foreground">
              <span>Step {currentStep + 1} of {steps.length}</span>
              <span>{Math.round(progress)}% Complete</span>
            </div>
            <Progress value={progress} className="h-2" />
          </div>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-4 py-8">
        <Card className="shadow-lg border-0">
          <CardContent className="p-8">
            {currentStepData.category && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary mb-6">
                {currentStepData.category}
              </span>
            )}

            <h1 className="text-2xl font-bold mb-8">{currentStepData.title}</h1>

            {currentStepData.type === "select" && (
              <Select value={formData.department} onValueChange={value => setFormData(prev => ({ ...prev, department: value }))}>
                <SelectTrigger className="h-12 text-base">
                  <SelectValue placeholder="Select Category" />
                </SelectTrigger>
                <SelectContent>
                  {departments.map(dept => <SelectItem key={dept} value={dept}>{dept}</SelectItem>)}
                </SelectContent>
              </Select>
            )}

            {currentStepData.type === "rating" && (
              <RadioGroup
              value={formData[currentStepData.id]?.selectedOption || ""}
              onValueChange={(value) =>
                updateOption(currentStepData.id, value)
              }
              className="space-y-3"
            >
                {ratingOptions.map(option => (
                  <div key={option} className="flex items-center space-x-3 rounded-lg hover:bg-accent/50 transition-colors">
                    <RadioGroupItem value={option} id={`${currentStepData.id}-${option}`} />
                    <Label htmlFor={`${currentStepData.id}-${option}`} className="text-base cursor-pointer">{option}</Label>
                  </div>
                ))}
              </RadioGroup>
            )}

            {currentStepData.type === "textarea" && (
              <Textarea
              placeholder="Share your thoughts..."
              value={formData[currentStepData.id] || ""}
              onChange={(e) =>
                updateTextarea(currentStepData.id, e.target.value)
              }
                className="min-h-[120px]"
              />
            )}
          </CardContent>
        </Card>

        <div className="flex items-center justify-between mt-8">
          <Button onClick={prevStep} disabled={currentStep === 0} variant="outline" className="flex items-center gap-2">
            <ChevronLeft className="w-4 h-4" /> Previous
          </Button>
          {currentStep === steps.length - 1 ? (
            <Button
              onClick={handleSubmit}
              className="flex items-center gap-2 px-8 !bg-primary !text-primary-foreground !opacity-100 hover:!bg-primary/90"
            >
              Submit Feedback <Heart className="w-4 h-4" />
            </Button>
          ) : (
            <Button
              onClick={nextStep}
              disabled={!canProceed()}
              className="flex items-center gap-2 px-8 !bg-primary !text-primary-foreground hover:!bg-primary/90"
            >
              Next <ChevronRight className="w-4 h-4" />
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
